/**
* @name: page-card-space
* @author: weiyong
* @date: 2023-03-31 20:45
* @description：page-card-space
* @update: 2023-03-31 20:45
*/
<template>
  <div :class="prefixCls" class="themeAttr-item">
    <span class="themeAttr-item-title">{{t('圆角度')}}</span>
    <div class="themeAttr-item-body w100b">
      <a-slider id="test" v-model:value="baseBorderRaduis" :max="30" :min="0" :marks="marks"/>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "left-menu-space",
});
</script>

<script lang="ts" setup>
import {Slider as aSlider} from "ant-design-vue";
import {useDesign} from "@/hooks/web/useDesign";
import {baseHandler} from "@/layouts/default/setting/handler";
import {HandlerEnum} from "@/layouts/default/setting/enum";
import {useI18n} from "vue-i18n";
import {useRootSetting} from "@/hooks/setting/useRootSetting";
import {setCssVar} from "@/logics/theme/util";
import {BASE_BORDER_RADUIS} from "@/logics/initAppConfig";
const {t} = useI18n();
const { getBaseBorderRaduis } = useRootSetting();

const baseBorderRaduis=ref(unref(getBaseBorderRaduis));
const marks = ref<Record<number, any>>({
  4: '4px',
  8: '8px',
  12: '12px',
  16: '16px',
  20: '20px',
  24: '24px',
});

//设置卡片空间
watch(baseBorderRaduis,(newVal)=>{
  baseHandler(HandlerEnum.BASE_BORDER_RADUIS_SET, unref(newVal));
  setCssVar(BASE_BORDER_RADUIS, newVal+'px');
})
const {prefixCls} = useDesign('page-card-space');
</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-page-card-space';

.@{prefix-cls} {
  width: 100%;
  padding: 16px;
  margin-bottom: 10px;
  border-radius: 6px;
  background: #fff;
  font-family: PingFangSC-Semibold,PingFang SC;
  .themeAttr-item-body{
    flex-wrap: wrap;
  }
  .themeAttr-item-title {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #111;
    margin-bottom: 14px;
  }
  .itme-title-span{
    text-align: center;
    margin-top: 6px;
  }
  .item-type-sign {
    width: 56px;
    height: 56px;
    padding: 3px;
    border: 1px solid #fff;
    border-radius: 3px;
    margin-right: 12px;
  }
}
</style>
